import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAppIcChatNew24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "New_Message",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	style: { fill: "currentColor" },
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m19,2c1.62,0,3,1.22,3,2.79v10.19c0,1.6-1.22,3-2.82,3H7.94c-.19,0-.42.05-.59.21l-3.66,3.52c-.21.21-.47.28-.68.28-.51,0-1.01-.5-1.01-1V5c0-1.68,1.37-3,3-3h14Zm-14.01,2c-.54,0-.99.5-.99,1v13.64l1.85-1.83c.47-.42,1.08-.8,1.69-.8h11.46c.54-.01,1-.5,1-1.01V5c0-.49-.48-1-1-1H4.99Zm10.01,5h-2v-2c0-.55-.45-1-1-1s-1,.45-1,1v2h-2c-.55,0-1,.45-1,1s.45,1,1,1h2v2c0,.55.45,1,1,1s1-.45,1-1v-2h2c.55,0,1-.45,1-1s-.45-1-1-1Z" })
});
export default SvgAppIcChatNew24;
